interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
}

export default function Skeleton({
  width,
  height,
  borderRadius,
  className = '',
}: SkeletonProps): React.JSX.Element {
  return (
    <div
      className={`skeleton ${className}`}
      style={{ width, height, borderRadius }}
      aria-hidden="true"
    />
  );
}

export function SkeletonText({ width = '100%' }: { width?: string }): React.JSX.Element {
  return <Skeleton width={width} height="14px" borderRadius="4px" />;
}
